import { Routes } from '@angular/router';
import { v2On } from '../v2/ui-v2.guard';

export const availabilityRoutes: Routes = [
  {
    path: 'availability',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/calendar/availability-v2.page').then(m => m.AvailabilityV2Page)
  },
  {
    path: 'availability',
    loadComponent: () => import('./availability.page').then(m => m.AvailabilityPage)
  }
];
